import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBranchState, IBranch, IBranchDetails } from "./branchModal";
import {
  getAllBranches,
  createBranch,
  updateBranch,
  deleteBranch,
  getBranchByID,
  getAllActiveBranches,
  activeInActiveBranch,
} from "./services/branch.services";

const initialState: IBranchState = {
  loading: false,
  formLoading: false,
  error: "",
  BranchID: null,
  DeleteBranchID: null,
  BranchList: [],
  BranchDetails: {
    ID: null,
    BranchName: "",
    BranchAddress: "",
    CityID: "",
    StateID: "",
    Pincode: "",
    MobileNumber: "",
    Email: "",
    IsActive: 1,
  },
};

const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {
    clearBranchDetails: (state) => {
      state.BranchDetails = initialState.BranchDetails;
    },
    setBranchID: (state, action: PayloadAction<number | null>) => {
      state.BranchID = action.payload;
    },
    clearBranchID: (state) => {
      state.BranchID = initialState.BranchID;
    },
    setDeleteBranchID: (state, action: PayloadAction<number | null>) => {
      state.DeleteBranchID = action.payload;
    },
    clearDeleteBranchID: (state) => {
      state.DeleteBranchID = initialState.DeleteBranchID;
    },
  },
  extraReducers: (builder) => {
    // Get All Branches
    builder.addCase(getAllBranches.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBranches.fulfilled,
      (state, action: PayloadAction<IBranch[]>) => {
        state.loading = false;
        state.BranchList = action.payload || [];
      },
    );
    builder.addCase(getAllBranches.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BranchList = [];
    });

    // Get All Active Branches
    builder.addCase(getAllActiveBranches.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveBranches.fulfilled,
      (state, action: PayloadAction<IBranch[]>) => {
        state.loading = false;
        state.BranchList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveBranches.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BranchList = [];
    });

    // Create Branch
    builder.addCase(createBranch.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createBranch.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createBranch.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update Branch
    builder.addCase(updateBranch.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateBranch.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateBranch.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete Branch
    builder.addCase(deleteBranch.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBranch.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBranch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Get Branch By ID
    builder.addCase(getBranchByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(
      getBranchByID.fulfilled,
      (state, action: PayloadAction<IBranchDetails>) => {
        state.formLoading = false;
        state.BranchDetails = action.payload;
      },
    );
    builder.addCase(getBranchByID.rejected, (state, action) => {
      state.formLoading = false;
      state.BranchDetails = initialState.BranchDetails;
      state.error = action.error.message || "Something went wrong";
    });

    // Active/Inactive Branch
    builder.addCase(activeInActiveBranch.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInActiveBranch.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInActiveBranch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearBranchDetails,
  setBranchID,
  clearBranchID,
  setDeleteBranchID,
  clearDeleteBranchID,
} = branchSlice.actions;
export default branchSlice.reducer;
